var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticStyle:{"height":"100%","line-height":"normal"},attrs:{"no-gutters":"","align":"center"}},[_c('ExBundleStatus',{attrs:{"bundleAssignment":_vm.assignment,"isGroupAdmin":_vm.isGroupAdmin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }